export * from './new.component';
